import { AppState } from '../states/app.state';
import { createSelector } from '@ngrx/store';
import { FormAttributesState } from '../states/form-attributes.state';

const formAttributesState = (state: AppState) => state.formAttributes;

export const selectFormAttributes = createSelector(
  formAttributesState,
  (state: FormAttributesState) => state.formAttributes
);

export const selectFormAttributesLoadedFormId = createSelector(
  formAttributesState,
  (state: FormAttributesState) => state.loadedFormId
);

/** Only returns attributes when the store slice matches this form (ignores modal/other screens). */
export const selectFormAttributesForFormId = (formId: number) =>
  createSelector(
    selectFormAttributes,
    selectFormAttributesLoadedFormId,
    (formAttributes, loadedFormId) =>
      Number(loadedFormId) === Number(formId) ? formAttributes : undefined
  );
